import { CustomObservables } from "app/custom-observables";
import entityBase from "entityBase";
import * as ko from "knockout";
import { solution_text } from "organized";

export class taskHistory extends entityBase {
  task_id: KnockoutObservable<string>;
  task_type: KnockoutObservable<string>;
  task_status: KnockoutObservable<string>;
  task_description: KnockoutObservable<string>;
  req_description: KnockoutObservable<string>;
  created_dt: KnockoutObservable<Date>;
  created_dttm: KnockoutComputed<string>;
  modified_dt: KnockoutObservable<Date>;
  modified_dttm: KnockoutComputed<string>;
  assigned_person_name: KnockoutObservable<string>;
  solution_text: KnockoutObservableArray<solution_text>;
  constructor(item) {
    super();
    this.task_id = ko.observable(item.task_id);
    this.task_type = ko.observable(item.task_type);
    this.task_status = ko.observable(item.task_status);
    this.task_description = ko.observable(item.description);
    this.req_description = ko.observable(item.request ? item.request.cust_prob_descr : "");
    this.created_dt = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.created_dttm = CustomObservables.formattedDateTimeObservable(this.created_dt);
    this.modified_dt = ko.observable(this.formatJSONDate(item?.modified_dttm));
    this.modified_dttm = CustomObservables.formattedDateTimeObservable(this.modified_dt);
    this.assigned_person_name = ko.observable(item?.assigned_person_name);
    this.solution_text = <KnockoutObservableArray<solution_text>>(
      this.loadRelation(item, solution_text, "task_text", "array")
    );
  }
}
